/**
 * Especifica una root variable de css
 * @param variable
 * @param value
 */
export const setRootVariable = (variable: string, value: string) => {
  const root = document.querySelector(':root') as HTMLElement | null;
  if (root !== null) {
    root.style.setProperty(variable, value);
  }
};

/**
 * Obtiene un valor de los query params por su nombre
 * @param paramName - Nombre del parámetro a buscar en los query params
 * @returns El valor del parámetro o undefined si no existe
 */
export function getQueryParam(paramName: string): string | undefined {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(paramName) || undefined;
}

/**
 * Retorna el ref de los query params
 */
export function getRefChatQs(): string {
  return getQueryParam('ref') ?? 'noref';
}

export function trackUpa(pageviewid: string | undefined, event_name: string, domain: string = 'undefined'): void {
  if (typeof pageviewid === 'string') {
    fetch('/hermes-service/topic/chat_ia_interaction', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        pageview_id: pageviewid,
        event_name,
        event_type: 'system',
        data: {
          url: window.location.href,
          ref: getRefChatQs(),
          domain,
        },
      }),
    }).catch(() => {
      console.error('Error sending chat_ia_interaction event');
    });
  }
}
